import { ICoinSearched } from "../interfaces/coinSearched";

export const COINS_PER_PAGE = 20;

export const BITCOIN_SEARCHED: ICoinSearched = {
  id: 'bitcoin',
  name: 'Bitcoin',
  api_symbol: '',
  symbol: 'BTC',
  market_cap_rank: 1,
  thumb: '',
  large: '',
}